// ServiceOverview/ServiceOverviewEngine.js
// FE Engine Pattern V2 (rk=beeca47db94541d594bc4aa830f62672) — initial REST fetch of all plugin states,
// then live SignalR push (OnSystemStateUpdated), both write to ServiceOverviewCache per instance. Singleton.
import { events } from '@/services/wss/SystemEvents';
import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import WssEventHandlerBase from '@/services/engines/WssEventHandlerBase';
import serviceOverviewCache from './ServiceOverviewCache';
import serviceOverviewFetcher from './ServiceOverviewFetcher';

const _name = 'ServiceOverviewEngine';

class ServiceOverviewEngine extends WssEventHandlerBase {
    _name = _name;
    _failed = false;

    bootup() {
        super.bootup();
        this.clear();

        this._unsub = this._wsNotifier.subscribe(events.OnSystemStateUpdated, this.onMessage);
    }

    clear() {
        super.clear();
        serviceOverviewCache.clear();
        this._failed = false;
        if (this._unsub) this._unsub();
    }

    /**
     * BE push — array of PluginState, overwrites the cached state per instance.
     * @param {object[]} data
     */
    onMessage = (data) => {
        try {
            serviceOverviewCache.addOrUpdate(data);
            this._notify();
        } catch (error) {
            this.logError('onMessage', error.message);
        }
    };

    /**
     * Initial fetch — all plugin states in one call. Live updates come via onMessage.
     * @returns {Promise<void>}
     */
    fetch = async () => {
        try {
            const items = await serviceOverviewFetcher.fetch();
            this._failed = items === null;
            if (items) serviceOverviewCache.setAll(items);

            this._notify();
        } catch (error) {
            this.logError('fetch', error.message);
        }
    };

    getAll = () => serviceOverviewCache.getAll();

    hasError = () => this._failed;

    _notify = () => {
        ComponentNotifier.notify(_name, 'dataChanged', {});
    };
}

const serviceOverviewEngine = new ServiceOverviewEngine();
export default serviceOverviewEngine;
